// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"28f27427","669":"47e3af21","796":"af5a2964"}[chunkId] + ".chunk.js";
};